import React, { useContext } from 'react';
import { AppContext } from '../../../..';

type Shift = { startTime: string; endTime: string; shiftNumber: number };
type Assignment = { id: string; costCenterId: number; costCenterName: string; startTime: string; endTime: string };
type DayRow = { id: string; date: string; shifts: Shift[]; assignments: Assignment[] };

type Props = {
  rows: DayRow[];
};

export const DistributionSummary: React.FC<Props> = ({ rows}) => {

  const { langResources, activeSkinConfig } = useContext(AppContext);

  if (!rows || rows.length === 0) {
    return (
      <div className='cost-center-distribution-summary'>
        <h6><i className='mdi mdi-view-list'></i> {langResources['cost.center.modal'].distribution?.title}</h6>
        <div className='distribution-empty'>{langResources['cost.center.modal'].distribution?.empty}</div>
      </div>
    );
  }

  return (
    <div className='cost-center-distribution-summary'>
      <h6><i className='mdi mdi-view-list'></i> {langResources['cost.center.modal'].distribution?.title}</h6>
      <table className='distribution-table'>
        <thead>
          <tr>
            <th style={{ width: '15%' }}>{langResources['cost.center.modal'].distribution?.table?.header?.date}</th>
            <th style={{ width: '12%' }}>{langResources['cost.center.modal'].distribution?.table?.header?.shift}</th>
            <th style={{ width: '22%' }}>{langResources['cost.center.modal'].distribution?.table?.header?.shiftTime}</th>
            <th style={{ width: '28%' }}>{langResources['cost.center.modal'].distribution?.table?.header?.costCenter}</th>
            <th style={{ width: '23%' }}>{langResources['cost.center.modal'].distribution?.table?.header?.assignedTime}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row =>
            row.shifts.map((shift, shiftIdx) => (
              <tr key={`${row.id}-${shiftIdx}`}>
                <td className='distribution-date'>
                  {shiftIdx === 0 && new Date(row.date + 'T00:00:00').toLocaleDateString('es-ES', { day: '2-digit', month: 'short' })}
                </td>
                <td>
                  <div className='distribution-shift'>
                    <span className='distribution-shift-badge' style={{ backgroundColor: `${activeSkinConfig.principalColor}20`, color: activeSkinConfig.principalColor }}>
                      T{shift.shiftNumber}
                    </span>
                  </div>
                </td>
                <td>
                  <div className='distribution-time'>
                    <i className='mdi mdi-clock-outline distribution-time-icon'></i>
                    <span>{shift.startTime} - {shift.endTime}</span>
                  </div>
                </td>
                <td>
                  {row.assignments.some(a => a.costCenterId !== -1) ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      {row.assignments
                        .filter(a => {
                          if (a.costCenterId === -1) return false;
                          const adjustedStartTime = a.endTime < a.startTime ? '00:00' : a.startTime;
                          if (shift.endTime < shift.startTime) {
                            return adjustedStartTime <= shift.endTime || a.endTime >= shift.startTime;
                          } else {
                            return shift.startTime <= a.endTime && adjustedStartTime <= shift.endTime;
                          }
                        })
                        .map(a => (
                          <span key={a.id} className='distribution-costcenter' style={{ borderLeftColor: activeSkinConfig.principalColor, color: activeSkinConfig.principalColor }}>
                            {a.costCenterName}
                          </span>
                        ))
                      }
                    </div>
                  ) : (
                    <span style={{ color: '#adb5bd', fontSize: 11, fontStyle: 'italic' }}>{langResources['cost.center.modal'].distribution?.noAssignment}</span>
                  )}
                </td>
                <td>
                  {row.assignments.some(a => a.costCenterId !== -1) ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                      {row.assignments
                        .filter(a => {
                          if (a.costCenterId === -1) return false;
                          const adjustedStartTime = a.endTime < a.startTime ? '00:00' : a.startTime;
                          if (shift.endTime < shift.startTime) {
                            return adjustedStartTime <= shift.endTime || a.endTime >= shift.startTime;
                          } else {
                            return shift.startTime <= a.endTime && adjustedStartTime <= shift.endTime;
                          }
                        })
                        .sort((a, b) => {
                          const aKey = a.endTime < a.startTime ? '00:00' : a.startTime;
                          const bKey = b.endTime < b.startTime ? '00:00' : b.startTime;
                          return aKey.localeCompare(bKey);
                        })
                        .map(a => (
                          <div key={a.id} className='distribution-hours'>
                            <i className='mdi mdi-timer-outline' style={{ fontSize: 11 }}></i>
                            {a.startTime} - {a.endTime}
                          </div>
                        ))
                      }
                    </div>
                  ) : (
                    <span style={{ color: '#adb5bd', fontSize: 11, fontStyle: 'italic' }}>{langResources['cost.center.modal'].distribution?.dash}</span>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default DistributionSummary;